import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, CheckCircle } from 'lucide-react'
import Container from './Container'

const BenefitsSima: React.FC = () => {
  return (
    <section className="bg-background-alt py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-0 right-0 -mr-32 -mt-32 w-96 h-96 bg-accent/10 rounded-full blur-3xl mix-blend-multiply pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 -ml-32 -mb-32 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl mix-blend-multiply pointer-events-none"></div>
      
      <Container size="lg" className="relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
            className="md:col-span-6 lg:col-span-5"
          >
            <h2 className="font-display text-3xl font-bold text-primary md:text-4xl lg:text-5xl mb-6 leading-tight">
              Por qué agendar una cita con Bavarian
            </h2>
            <p className="text-lg text-text-secondary mb-8">
              En una cita 1:1 te ayudamos a comparar ORIÓN y FOREST con criterios claros y a definir el siguiente paso según tu objetivo de inversión o estilo de vida.
            </p>

            <a
              href="#agenda"
              className="inline-flex items-center justify-center rounded-lg bg-accent px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-accent-dark shadow-luxury w-full sm:w-auto"
            >
              Agendar en IFEMA
              <ArrowRight className="ml-2 h-5 w-5 btn-arrow" />
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="md:col-span-6 lg:col-span-7"
          >
            <div className="grid grid-cols-1 gap-4">
              {[
                'Comparación rápida entre proyectos (sin ruido)',
                'Recomendación según presupuesto y timing',
                'Claridad de etapas, reservas y próximos pasos',
                'Acompañamiento en todo el proceso hasta la entrega'
              ].map((bullet, i) => (
                <div 
                  key={i} 
                  className="bg-white p-6 rounded-2xl border border-border-light flex items-center gap-4 hover:border-accent/30 hover:shadow-md transition-all duration-300"
                >
                  <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10">
                    <CheckCircle className="h-6 w-6 text-accent" />
                  </div>
                  <span className="font-medium text-primary text-lg">{bullet}</span>
                </div>
              ))}
            </div>
          </motion.div>

        </div>
      </Container>
    </section>
  )
}

export default BenefitsSima
